"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErrorMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconDisplay = require("../icons/IconDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonErrorMessage = function ButtonErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
      isPolite = _ref.isPolite,
      iconType = _ref.iconType;
  var containerProps = {
    className: 'button-error',
    'aria-live': isPolite ? 'polite' : 'assertive',
    'aria-atomic': true
  };
  /* leave the container in the DOM
   * so it will announce it's contents when they are added
   */

  return _react.default.createElement("span", containerProps, iconType && errorMessage && _react.default.createElement(_IconDisplay.Icon, {
    type: iconType
  }), errorMessage);
};

exports.ButtonErrorMessage = ButtonErrorMessage;
ButtonErrorMessage.defaultProps = {
  errorMessage: null,

  /* null for falsy object */
  isPolite: false,
  iconType: null
};
ButtonErrorMessage.propTypes = {
  errorMessage: _propTypes.default.string,
  isPolite: _propTypes.default.bool,
  iconType: _propTypes.default.string
};